const ErrorAlert = ({
  title = 'Error',
  message,
  variant = 'error',
  className = '',
  onDismiss
}) => {
  const variantStyles = {
    error: {
      bg: 'bg-coral-50',
      border: 'border-coral-500',
      titleColor: 'text-coral-800',
      messageColor: 'text-coral-700',
      iconColor: 'text-coral-600'
    },
    warning: {
      bg: 'bg-sunshine-50',
      border: 'border-sunshine-500',
      titleColor: 'text-sunshine-800',
      messageColor: 'text-sunshine-700',
      iconColor: 'text-sunshine-600'
    },
    info: {
      bg: 'bg-teal-50',
      border: 'border-teal-500',
      titleColor: 'text-teal-800',
      messageColor: 'text-teal-700',
      iconColor: 'text-teal-600'
    }
  };

  const styles = variantStyles[variant] || variantStyles.error;

  if (!message) return null;

  return (
    <div className={`rounded-lg ${styles.bg} border-2 ${styles.border} p-4 ${className}`}>
      <div className="flex gap-3">
        <div className="flex-shrink-0">
          <svg className={`h-5 w-5 ${styles.iconColor}`} viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className={`text-sm font-bold ${styles.titleColor}`}>
            {title}
          </h3>
          <p className={`text-sm font-medium ${styles.messageColor} mt-1`}>
            {message}
          </p>
        </div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className={`flex-shrink-0 ${styles.iconColor} hover:opacity-75 transition-opacity touch-manipulation`}
            aria-label="Dismiss"
          >
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorAlert;
